import { render, staticRenderFns } from "./LayoutContentHorizontalNav.vue?vue&type=template&id=51236c00&scoped=true"
import script from "./LayoutContentHorizontalNav.vue?vue&type=script&lang=js"
export * from "./LayoutContentHorizontalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentHorizontalNav.vue?vue&type=style&index=0&id=51236c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51236c00",
  null
  
)

export default component.exports